import * as React from "react";
import AlaUne from "./AlaUne";
import ProchainEvent from "./ProchainEvent";
import DernierEvent from "./DernierEvent";


function Event() {
  return (
    <main>
    <AlaUne/>
    <ProchainEvent/>
    <DernierEvent/>
    
    </main>
  );
}

export default Event;